import Tabs from '../../components/other/NTabs/Tabs';
import Dropdown from '../../components/other/NDropdown/Dropdown';
import 'swiper/css';
import 'swiper/css/pagination';
import './сorporateСlients.scss';

(function () {
    const $tabs = document.querySelectorAll('.js-tabs');
    const $dropdownList = document.querySelectorAll('.js-dropdown');
    const $cellInput = document.querySelector('.js-cell');
    const $cellSelect = document.querySelector('.js-cell-select');
    // const $menuButton = document.querySelector('.js-menu-button');
    const $menuContent = document.querySelector('.menu__content');
    const $body = document.querySelector('.body');

    // Добаввление свойство блокировки прокрутки body при активном меню
    // $menuButton.addEventListener('click', toggleMenu);
    //

    $tabs.forEach((tab) => {
        new Tabs(tab);
    });

    $dropdownList.forEach((dropdown) => {
        new Dropdown(dropdown);
    });

    const button = document.querySelector('.b-footer__agreement_link2');
    button.addEventListener('click', function () {
        button.classList.toggle('active');
    });
})();
